import { render, staticRenderFns } from "./FreshdeskList.vue?vue&type=template&id=18807158&"
import script from "./FreshdeskList.vue?vue&type=script&lang=js&"
export * from "./FreshdeskList.vue?vue&type=script&lang=js&"
import style0 from "./FreshdeskList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports